import _ from 'underscore';
import FireBaseTools from '../utils/firebase';

import {
    UPDATE_INPUT_FUEL_RECORD,
    UPDATE_INPUT_BILL_PHOTO_URL,
    SUBMIT_FUEL_RECORD,
    CLEAR_ONE_FUEL_RECORD,
    UPDATE_FUEL_RECORD,
} from './types';
import {
    updateFuelRecordToFirebase,
    submitNewRecordToFirebase,
} from '../helpers/firebase';

const defaultFuelRecord = {
    carKey: null,
    sum: null,
    billPhotoURL: null,
    type: null,
    km: null,
};

export function updateInputFuelRecord(data, name) {
    let obj = {};
    obj[name] = data;

    return {
        type: UPDATE_INPUT_FUEL_RECORD,
        payload: obj,
    };
}

export function updateInputBillPhotoURL(photoURL) {
    return {
        type: UPDATE_INPUT_BILL_PHOTO_URL,
        payload: {
            "billPhotoURL": photoURL,
        },
    };
}

export async function submitFuelRecord(record) {
    const user = await FireBaseTools.fetchUser();

    const recordWithUID = _.extend({} ,record, { "ownerId": user.uid });
    const recordKey = await submitNewRecordToFirebase(recordWithUID);

    const recordWithKey = _.extend({} ,recordWithUID, {
        'key': recordKey,
        'dateAdd': Date.now(),
    });

    return {
        type: SUBMIT_FUEL_RECORD,
        payload: recordWithKey,
    };
}

export function clearOneFuelRecord() {
    return {
        type: CLEAR_ONE_FUEL_RECORD,
        payload: defaultFuelRecord,
    };
}

export function updateFuelRecord(record) {
    const result = updateFuelRecordToFirebase(record);

    return {
        type: UPDATE_FUEL_RECORD,
        payload: record,
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/one_fuel_record_actions.js